import componentServices from 'Scripts/componentServices';
import InspectionQueue from './fieldInspectionQueue';
import { FieldInspectionOverview } from './fieldInspectionOverview';
import { FieldInspectionVisit } from './fieldInspectionVisit';

componentServices.router.addRoutes([{
	path: '/inspection/queue',
	component: InspectionQueue,
	contentClass: '',
	onEnter: componentServices.router.requireUser(componentServices.router.requireModule('inspection'))
}, {
	path: '/inspection/:jobcostkey/overview',
	component: FieldInspectionOverview,
	contentClass: '',
	onEnter: componentServices.router.requireUser(componentServices.router.requireModule('inspection'))
}, {
	path: '/inspection/:jobcostkey/inspect/:visitkey',
	component: FieldInspectionVisit,
	contentClass: '',
	onEnter: componentServices.router.requireUser(componentServices.router.requireModule('inspection'))
}, {
	path: '/inspection',
	onEnter: ({ replace }) => {
		replace('/inspection/queue');
		// cancel the route transition
		return false;
	}
}]);